// export const BASE_URL = "http://localhost:8080";
export const BASE_URL = "";
export const SOCKET_URL = 'ws://localhost:8080/ws';
export const JSON_HEADER_CONFIG = {
    headers: {
        'Content-Type': 'application/json;charset=UTF-8',
    }
};

export const JSON_HEADER_CONFIG_BEARER = function(access_token) {
    return {
        headers: {
            'Content-Type': 'application/json;charset=UTF-8',
            'Authorization': `Bearer ${access_token}`
        }
    }
}

export const getDefaultPlayerData = function() {
    return {
        seed: "0",
        gameconfig: {},
        avatarconfig: {
            name: '',
            gender: 'U',
            hat: 0,
            hair: 0,
            face: 0,
            topwear: 0,
            bottomwear: 0,
            accessory: 0,
        },
        progress: {
            story: 0,
        },
        virtualassets: {
            zeny: 0,
        },
    };
}